import * as React from "react";
import { IParagraphFrequentlyAskedQuestionsProps } from "./ParagraphFrequentlyAskedQuestionsProps";
import { Container } from "./ParagraphFrequentlyAskedQuestionsHelpers";
import { graphql } from "gatsby";
import FrequentlyAskedQuestions from "../../common/FrequentlyAskedQuestions/FrequentlyAskedQuestions";

const ParagraphFrequentlyAskedQuestions: React.FC<
  IParagraphFrequentlyAskedQuestionsProps
> = (props) => {
  return (
    <Container className="container-sm">
      <FrequentlyAskedQuestions {...props} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphFrequentlyAskedQuestions on paragraph__frequently_asked_questions {
    id
    field_search_field_required
    parent_type
    field_title
    field_description
    field_subtitle
    relationships {
      field_sites {
        machine_name
      }
      faq_sections: field_questions {
        id
        field_title
        relationships {
          field_questions {
            id
            question: field_title
            answer: field_description_formatted {
              processed
              value
            }
          }
        }
      }
    }
  }
`;
export default ParagraphFrequentlyAskedQuestions;
